import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../store/store";
import { commonActions } from "../../features/common/redux/slice";
import { clearAppError } from "../../features/common/redux/globalActions";
import { applyThemeBackground } from "../../utils";

const RouteChangeListener = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  // const firstRender = useRef(true);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    // if (!firstRender.current) {
    //   firstRender.current = false;
    //   return;
    // }

    const ignoredRoutes = [
      "",
      "/",
      "/profile/about-me",
      "/profile/my-pets",
      "/profile/my-pets/create",
      "/profile/my-pets/view",
      "/profile/my-pets/edit",
      "/profile/address",
      "/profile/phone",
      "/profile/notification",
      "/profile/password",
      "/profile/delete",
      "/sitter/address",
      "/sitter/headline",
      "/sitter/payout-method",
      "/sitter/photo-gallery",
      "/sitter/experience",
      "/reset-password",
      "/verify-email",
    ];

    applyThemeBackground();

    const isIgnored = ignoredRoutes.some((route) =>
      location.pathname.startsWith(route),
    );

    if (!isIgnored) {
      dispatch(commonActions.startPageLoading());
      dispatch(clearAppError());
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      dispatch(commonActions.stopPageLoading());
    }, 800);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [location.pathname]);

  // Temporarily commented out
  // useEffect(() => {
  //   destroyAllNotifications?.();
  // }, [location.pathname]);

  return null;
};

export default RouteChangeListener;
